<template>
    <div class="seccion_cardsOpciones my-4">
                <center class="mt-5 mb-4">
                    <h5 class="subtitulo2 mb-2">Fondo de Protección para Vehículos Propiedad del Poder Ejecutivo Estatal</h5>
                </center>
                    <div class="row px-5 d-flex align-items-center justify-content-between">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name: 'quienesSomos'}">
                            <div class="card mb-3 p-1" >
                                <div class="row no-gutters">
                                <!---Imagen de la card-->
                                <div class="col-md-4 p-2 text-center justify-content-center" >
                                    <!-- <img src="imagenes/img1.jpg" alt=""> -->
                                    <i class='bx bx-pencil icono_card'></i>
                                </div>
                                <!---Texto de la card-->
                                <div class=" col-md-8">
                                    <div class="card-body">
                                    <h5 class="titulo_subsec card-title mb-4">¿Quiénes Somos?</h5>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </router-link>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <router-link :to="{name: 'informacion'}">
                            <div class="card mb-3 p-1" id="seleccionado">
                                <div class="row no-gutters">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                    <!-- <img src="imagenes/img2.jpg" alt=""> -->
                                    <i class='bx bx-list-check icono_card'></i>
                                    </div>
                                    <div class="col-md-8">
                                    <div class="card-body">
                                        <h5 class="titulo_subsec card-title mb-4">Información</h5>
                                    </div>
                                    </div>
                                </div>
                                </div>
                        </router-link>
                    </div>          
                    </div>
                    <div class="row px-5 d-flex align-items-center justify-content-between">
                        <div class="col-xs-12 col-sm-12 col-md-6">
                            <router-link :to="{name: 'otros'}">
                                <div class="card mb-3 p-1">
                                    <div class="row no-gutters d-flex">
                                    <div class="col-md-4 p-2 text-center justify-content-center">
                                    <!-- <img src="imagenes/img3.jpg" alt=""> -->
                                    <i class='bx bx-donate-blood icono_card'></i>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card-body  justify-content-center">
                                        <h5 class="titulo_subsec card-title mb-4">Otros Documentos</h5>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>    
</template>
<script>
export default {
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>